module.exports = __webpack_public_path__ + "static/mission-3c72b01c43a10d34c2d828b13c14bfd0.svg";